import { combineReducers } from '@reduxjs/toolkit';

import contentPageSlice from '../../Contents/Actions/reducer';
import landingMainPageSlice from '../../Main/Actions/reducer';

export const landingReducers = combineReducers({
  landingMainPage: landingMainPageSlice,
  contentPage: contentPageSlice,
});
